import { SendOutlined } from '@ant-design/icons';

import type { FC } from 'react';

export const RegisterHint: FC = () => (
  <div className="RegisterHint">
    <SendOutlined className="RegisterHint__icon" />
    <div className="RegisterHint__content">
      <h3 className="RegisterHint__title">
        Зарегистрируйся и начни работать бесплатно!
      </h3>
      <p className="RegisterHint__text">
        Пришло время увеличить продажи и автоматизировать рутинную работу
      </p>
    </div>
  </div>
);
